<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('common_29')}}</div>
    <div slot="body">
       <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_420')" v-bind="formItemLayout">
          <a-select v-decorator="decorators.currency" :placeholder="$t('common_383')">
            <a-select-option value="CNY">{{$t('bill.text_30')}}</a-select-option>
            <a-select-option value="USD">{{$t('scope.text_469')}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'UpdatePaidCurrencyDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      scope: this.$store.getters.scope,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        currency: [
          'currency',
          {
            initialValue: this.params.data[0].billing_subscription.paid_currency,
            rules: [
              { required: true, message: this.$t('common_383') },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  methods: {
    doUpdate (data) {
      return new this.$Manager('billing_subscriptions').update({
        id: this.params.data[0].billing_subscription_id,
        data: data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doUpdate({ paid_currency: values.currency })
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('common_396'))
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
